import axios from "axios"

const STORAGE_KEY = "gymflow_auth"

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8080/api"

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
})

api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const { token } = JSON.parse(raw)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
  } catch {
    // ignore
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = String(error.config?.url || "")
      if (!url.includes("/login")) {
        localStorage.removeItem(STORAGE_KEY)
        if (window.location.pathname !== "/login") {
          window.location.assign("/login")
        }
      }
    }
    return Promise.reject(error)
  }
)

export default api
